export default "__VITE_ASSET__BLOVfqEk__"